import React from 'react'
// import abimg1 from '../../images/video/video-image.png'
import VideoModal from '../ModalVideo';


const VideoSection = (props) => {
    
    return (
        <div className={`video-section pt-185 ${props.vclass}`}>
            <div className="container">
                <div className="video-inner">
                    <img src="https://res.cloudinary.com/dcpte972l/image/upload/v1705582495/pexels-aleksandar-pasaric-2115367_xtojji.jpg" alt="Video" />
                   <VideoModal/>
                </div>
            </div>
        </div>
    )
}

export default VideoSection;